var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module cercaliagl/control/LayerSwitcher
 */
import Control from './Control';
import MapControls from './MapControls';
import MapTypes from '../MapTypes';
import { i18n } from '../dictionary';
import VDropDown, { EventType as DropDownEventType } from '../view/VLayerSwitcher';
import VControlButton from '../view/VControlButton';
/**
 * @typedef {Object} LayerSwitcherOptions
 * @property {Array.<string>|undefined} mapLayers  Maps array to be painted. Admitted values:<br/>
 * `cercaliagl.MapTypes.CERCALIA`<br>
 * `cercaliagl.MapTypes.OSM`<br/>
 * `cercaliagl.MapTypes.SATELLITE`<br/>
 * `cercaliagl.MapTypes.DARK`<br/>
 * `cercaliagl.MapTypes.SYLVER`<br/>
 * `cercaliagl.MapTypes.EMPTY`<br/>
 * @property {string} active Active base layer id
 */
/**
 * @classdesc
 * <b>Javascript ES5</b>
 *
 * ```js
 * const control = new cercaliagl.control.LayerSwitcher();
 * ```
 * <br/>
 * This is a layer switcher control. Base layer can be changed via this control.
 * It is possible to add custom layers. You can see some examples in `Examples` page.
 * @constructor
 * @extends {Control}
 * @api
 */
var LayerSwitcher = /** @class */ (function (_super) {
    __extends(LayerSwitcher, _super);
    /**
     * @param {LayerSwitcherOptions} [options] Options
     */
    function LayerSwitcher(options) {
        if (options === void 0) { options = {}; }
        var _this = this;
        var controlButton = new VControlButton('layers');
        var element = controlButton.getElement();
        _this = _super.call(this, {
            element: element,
            className: 'cercaliagl.control.LayerSwitcher',
            name: MapControls.LAYER_SWITCHER,
        }) || this;
        /**
         * @private
         * @type {VControlButton}
         */
        _this.controlButton_ = controlButton;
        /**
         * @private
         * @type {HTMLElement}
         */
        _this.element_ = element;
        /**
         * @private
         * @type {Array.<string>}
         */
        _this.mapLayers_ = options.mapLayers !== undefined
            ? options.mapLayers : [MapTypes.CERCALIA, MapTypes.DARK, MapTypes.SILVER, MapTypes.BLANKMAP, MapTypes.OSM, MapTypes.SATELLITE];
        /**
         * @private
         * @type {VDropDown}
         */
        _this.dropdown_ = new VDropDown();
        _this.initialize_(options.active);
        return _this;
    }
    /**
     * @private
     */
    LayerSwitcher.prototype.initialize_ = function (activeBaselayerId) {
        var _this = this;
        this.controlButton_.setTooltip(i18n('tooltipLayerSwitcher'));
        this.initializeBaselayers_();
        this.dropdown_.setSelected(activeBaselayerId);
        // Events
        this.element_.addEventListener('click', this.handleClick_.bind(this));
        window.addEventListener('resize', function () { return _this.adjustPosition_(_this.dropdown_); });
        this.dropdown_.on(DropDownEventType.SELECTED, this.handleBaselayerChange_.bind(this));
    };
    /**
     * @private
     */
    LayerSwitcher.prototype.initializeBaselayers_ = function () {
        var _this = this;
        Object.entries(MapTypes).forEach(function (_a) {
            var mapType = _a[1];
            if (_this.mapLayers_.indexOf(mapType) !== -1) {
                _this.addLayer(mapType, mapType);
            }
        });
    };
    /**
     * @param {string} id Layer id.
     * @param {string} label Label
     */
    LayerSwitcher.prototype.addLayer = function (id, label) {
        var item = {
            id: id,
            value: label,
        };
        this.dropdown_.add(item);
    };
    /**
     * @private
     */
    LayerSwitcher.prototype.handleClick_ = function () {
        if (!this.dropdown_.isVisible()) {
            var container = this.getMap().getContainer();
            if (!this.dropdown_.getElement().parentElement) {
                this.dropdown_.appendTo(container);
            }
            this.adjustPosition_(this.dropdown_);
            this.dropdown_.show();
        }
        else {
            this.dropdown_.hide();
        }
    };
    /**
     * Open dropdown user interface component
     * @api
     */
    LayerSwitcher.prototype.open = function () {
        this.dropdown_.show();
    };
    /**
     * Close dropdown user interface component
     * @api
     */
    LayerSwitcher.prototype.close = function () {
        this.dropdown_.hide();
    };
    /**
     * @private
     * @param {import("../view/VLayerSwitcher.js").Item} item Item
     */
    LayerSwitcher.prototype.handleBaselayerChange_ = function (item) {
        this.dropdown_.hide();
        this.changeBaseLayer(item.id);
    };
    /**
     * Change base layer with a given base layer id.
     * @api
     * @param {string} baselayerId Base layer id.
     */
    LayerSwitcher.prototype.changeBaseLayer = function (baselayerId) {
        var cercaliaMap = this.getCercaliaMap();
        cercaliaMap.changeBaseLayer(baselayerId);
        this.dropdown_.setSelected(baselayerId);
    };
    return LayerSwitcher;
}(Control));
export default LayerSwitcher;
//# sourceMappingURL=LayerSwitcher.js.map